<template>
    <div class='title-box'>
        <div class="title">{{title}}</div>
    </div>
</template>
<script>


export default {
    name: "report-title",

    // 组件注册
    components: {},
    data() {
        return {};
    },
    props: {
        title:{
            type: String,
            default:''
        }
    },
    //计算属性
    computed: {},
    // 数据监听
    watch: {},
    //方法集合
    methods: {},
    //生命周期 - 创建完成
    created() {
    },
    //生命周期 - 挂载完成
    mounted() {
    },
}
</script>
<style lang='scss' scoped>
.flc {
    display: flex;
    justify-content: center;
    align-items: center;
}

.flc2 {
    display: flex;
    align-items: center;
}

.positionc {
    position: absolute;
    left: 50%;
    transform: translate(-50%);
}

.title-box {
    width: 100%;
    padding: 32px 40px;
    .title {
        border-left:5px solid  #0D53FC;
        padding-left: 16px;
        font-size: 24px;
        font-weight: 500;
        color: #333333;
    }
}
</style>
